/** Canonical (AWS-style) Secret Manager id of a PagerDuty account's client
 * secret. Other providers rewrite it with their `replacer`. */
export const pagerdutyAiClientSecretSecretId = (accountId: string): string =>
  `p0/install/pagerduty/${accountId}/client-secret`;

/** Canonical prefix that every token secret of a PagerDuty account starts
 * with. Other providers rewrite it with their `replacer`. */
export const pagerdutyAiAccessTokenPrefix = (accountId: string): string =>
  `p0/access-token/pagerduty/${accountId}/`;

/** The connector's Cloud Run service name. Its Lambda function name adds
 * "-aws". */
export const pagerdutyAiConnectorName = "p0-connector-pagerduty-ai";
